<template>
  <div>
    <DialogCreate
      v-model="openModal"
      :iconTitle="require('@/assets/img/settings-icon.svg')"
      title="Crear cuenta de servicio"
      iconSuccess="settings"
      :labelSuccess="labelSuccess"
      :isLoading="isLoadingSaveAction"
      @save="triggerSaveButton"
      dataCy="save-cuentaservicio"
    >
      <template slot="body">
        <div v-if="!finishForm" class="form-new-cuentaservicio">
          <div class="row">
            <div class="col-12">
              <q-input
                v-model="v$.nameCuentaServicio.$model"
                outlined
                debounce="1000"
                :error="v$.nameCuentaServicio.$error"
                label="*Nombre"
                class="col-12"
                data-cy="name-cuentaservicio"
              >
                <template v-slot:error>Dato obligatorio.</template>
              </q-input>
            </div>
          </div>
          <div class="row">
            <div class="col-6" style="padding-right: 7px">
              <q-select
                data-cy="app-api-selected"
                outlined
                v-model="v$.aplicacionesApiSelected.$model"
                :options="aplicacionesOpts"
                option-value="id"
                option-label="name"
                label="Seleccione aplicación"
                :error="v$.aplicacionesApiSelected.$error"
                @input="selectAplicacion"
              >
                <template v-slot:error>Dato obligatorio.</template>
                <template
                  v-slot:option="{
                    itemProps,
                    itemEvents,
                    opt,
                    selected
                  }"
                >
                  <q-item
                    v-bind="itemProps"
                    v-on="itemEvents"
                    active-class="multiple-select-active"
                  >
                    <q-item-section :side="true">
                      <q-radio
                        :val="opt.id"
                        :value="selected ? opt.id : null"
                      />
                    </q-item-section>
                    <q-item-section
                      no-wrap
                      class="ellipsis multiple-select"
                      style="width: 100px"
                    >
                      <q-item-label>{{ opt.name }} </q-item-label>
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
            <div class="col-6" style="padding-left: 7px">
              <q-select
                data-cy="app-role"
                outlined
                multiple
                v-model="v$.roleAppApiSelected.$model"
                :options="roleAplicacionesApiOpts"
                option-value="id"
                option-label="name"
                label="Seleccione rol"
                :error="v$.roleAppApiSelected.$error"
                :loading="isLoadingroleAplicacionesApiOpts"
                @input="selectRole"
              >
                <template v-slot:error>Dato obligatorio.</template>
                <template
                  v-slot:option="{
                    itemProps,
                    itemEvents,
                    opt,
                    selected,
                    toggleOption
                  }"
                >
                  <q-item
                    v-bind="itemProps"
                    v-on="itemEvents"
                    active-class="multiple-select-active"
                  >
                    <q-item-section :side="true">
                      <q-checkbox
                        :value="selected"
                        @input="toggleOption(opt)"
                      />
                    </q-item-section>
                    <q-item-section
                      no-wrap
                      class="ellipsis multiple-select"
                      style="width: 100px"
                    >
                      <q-item-label>{{ opt.name }} </q-item-label>
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <q-chip
                v-for="roleRelationshipApp in chipRoleRelationship"
                :key="roleRelationshipApp.id"
                removable
                text-color="black"
                outline
                class="a"
                @remove="removeRoleRelationship(roleRelationshipApp)"
              >
                {{ roleRelationshipApp.name }}
                <span
                  v-for="roleRelationship in roleRelationshipApp.role"
                  :key="roleRelationship.id"
                  >/{{ roleRelationship.name }}</span
                >
              </q-chip>
            </div>
          </div>
        </div>
        <div v-else class="form-view-cuentaservicio row">
          <div class="col-12" style="padding: 0 45px 40px">
            <div class="form-view-cuentaservicio__title">Token</div>
            <div class="form-view-cuentaservicio__item-token-container">
              <div
                class="form-view-cuentaservicio__item-token-container__token-result"
                data-cy="copy-token"
              >
                {{ tokenResult }}
              </div>
              <div>
                <q-icon
                  name="file_copy"
                  style="color: #797979; font-size: 24px; cursor: pointer;"
                  @click="copyTokenToClipBoard()"
                />
              </div>
            </div>
          </div>
          <div></div>
        </div>
      </template>
    </DialogCreate>
  </div>
</template>

<script>
import DialogCreate from '@/shared/dialogs/create/DialogCreate.vue';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import Loading from '@/components/shared/mixins/Loading.js';
import Message from '@/components/shared/mixins/Message.js';
import { QRadio, copyToClipboard } from 'quasar';

export default {
  setup: () => ({ v$: useVuelidate() }),
  components: {
    DialogCreate,
    QRadio
  },
  validations: {
    nameCuentaServicio: { required },
    aplicacionesApiSelected: {},
    roleAppApiSelected: {}
  },
  props: {
    value: {
      required: true,
      type: Boolean,
      default: () => false
    },
    dependecyApp: {
      required: false,
      type: Object,
      default: () => {}
    },
    cuentaServicioSelected: {
      required: true,
      type: Object,
      default: () => {}
    }
  },
  mixins: [Loading, Message],
  computed: {
    chipRoleRelationship () {
      let structureChips = [];
      this.roleRelationship.map(e => {
        let exist = [];
        exist = structureChips.filter(c => c.id === e.aplicacionId);
        exist.length === 0
          ? structureChips.unshift(this.createChipsStructure(e))
          : exist[0].role.unshift({ id: e.roleId, name: e.roleName });
      });

      return structureChips;
    },
    labelSuccess () {
      return this.finishForm
        ? 'GUARDAR'
        : this.newMode
          ? 'CREAR CUENTA DE SERVICIO'
          : 'EDITAR CUENTA DE SERVICIO';
    },

    newMode () {
      return Object.keys(this.cuentaServicioSelected).length === 0;
    }
  },
  data () {
    return {
      isLoadingSaveAction: false,
      openModal: false,
      finishForm: false,
      tokenResult: null,
      roleRelationship: [],
      nameCuentaServicio: null,
      aplicacionesApiSelected: null,
      aplicacionesOpts: [],
      roleAppApiSelected: null,
      roleAplicacionesApiOpts: [],
      isLoadingroleAplicacionesApiOpts: false
    };
  },
  methods: {
    async loadAplicacionesOpts () {
      let aplicacionesOpts = [];
      this.showLoading();

      let request = {
        controller: '/Api'
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then(async response => {
          aplicacionesOpts = response.data;
        })
        .catch(err => {
          this.showError(err.message);
        })
        .finally(() => {
          this.hideLoading();
        });

      return aplicacionesOpts;
    },
    async loadRoleAplicaciones (aplicacion) {
      this.resetRoleAplicaciones();

      let idAplicacion = aplicacion.id;
      let request = {
        controller: `/Rol/${idAplicacion}`
      };

      this.showLoading();
      this.isLoadingroleAplicacionesApiOpts = true;
      await this.$store
        .dispatch('PF/getSuit', request)
        .then(response => {
          this.roleAplicacionesApiOpts = response.data;
          this.setSelectedRoleAplicaciones();
        })
        .catch(err => {
          this.showError(err.message);
        })
        .finally(() => {
          this.hideLoading();
          this.isLoadingroleAplicacionesApiOpts = false;
        });
    },
    async selectAplicacion (aplicacion) {
      await this.loadRoleAplicaciones(aplicacion);
    },
    selectRole (aplicacionRole) {
      return this.setRoleRelationShip(
        this.aplicacionesApiSelected,
        aplicacionRole
      );
    },
    structureRoleRelationship (dataAplicacion, dataRoleAplicacion) {
      return {
        aplicacionId: dataAplicacion.id,
        aplicacionName: dataAplicacion.name,
        roleId: dataRoleAplicacion.id,
        roleName: dataRoleAplicacion.name
      };
    },
    createStructureRoleRelationship (aplicacionRole, aplicacionApiSelected) {
      return aplicacionRole.map(e =>
        this.structureRoleRelationship(aplicacionApiSelected, e)
      );
    },
    createChipsStructure (data) {
      return {
        id: data.aplicacionId,
        name: data.aplicacionName,
        role: [{ id: data.roleId, name: data.roleName }]
      };
    },
    setRoleRelationShip (aplicacionApiSelected, aplicacionRole) {
      const aplicacionId = aplicacionApiSelected.id;
      const structureRoles = this.createStructureRoleRelationship(
        aplicacionRole,
        aplicacionApiSelected
      );
      const roleRelationshipFilteredByApiSelected = this.searchRoleRelationshipByaplicacionId(
        aplicacionId
      );

      if (roleRelationshipFilteredByApiSelected.length > 0) {
        this.cleanRoleRelationship(roleRelationshipFilteredByApiSelected);
      }

      if (structureRoles.length === 0) return;
      structureRoles.forEach(item => this.roleRelationship.unshift(item));
    },
    removeRoleRelationship (roleRelationship) {
      let aplicacionId = roleRelationship.id;
      const roleRelationshipFilteredByApiSelected = this.searchRoleRelationshipByaplicacionId(
        aplicacionId
      );

      if (roleRelationshipFilteredByApiSelected.length === 0) return;

      this.cleanRoleRelationship(roleRelationshipFilteredByApiSelected);
      this.resetAplicaciones();
      this.resetRoleAplicaciones();
    },
    cleanRoleRelationship (roleRelationshipFilteredByApiSelected) {
      roleRelationshipFilteredByApiSelected.forEach(e =>
        this.roleRelationship.splice(
          this.roleRelationship.findIndex(
            c => c.aplicacionId === e.aplicacionId
          ),
          1
        )
      );
    },
    searchRoleRelationshipByaplicacionId (aplicacionId) {
      return this.roleRelationship.filter(e => e.aplicacionId === aplicacionId);
    },
    setSelectedRoleAplicaciones () {
      const roleRelationship = this.searchRoleRelationshipByaplicacionId(
        this.aplicacionesApiSelected.id
      );
      if (roleRelationship.length === 0) return;
      this.roleAppApiSelected = roleRelationship.map(e => {
        return { id: e.roleId, name: e.roleName };
      });
    },
    resetFormCuentaServicio () {
      this.nameCuentaServicio = null;
      this.roleRelationship = [];
    },
    resetAplicaciones () {
      this.aplicacionesApiSelected = null;
    },
    resetRoleAplicaciones () {
      this.roleAppApiSelected = null;
      this.roleAplicacionesApiOpts = [];
    },
    resetFinishForm () {
      this.finishForm = false;
      this.tokenResult = null;
    },
    resetModal () {
      if (typeof this.v$.reset !== 'undefined') {
        this.v$.$reset();
      }

      this.resetFormCuentaServicio();
      this.resetAplicaciones();
      this.resetRoleAplicaciones();
      this.resetFinishForm();
    },
    closeModal () {
      this.resetModal();
      this.$emit('input', false);
    },
    validateForm () {
      this.v$.$touch();

      return this.v$.$error;
    },
    triggerSaveButton () {
      if (this.newMode) return this.createCuentaServicio();
      return this.editCuentaServicio();
    },
    async createCuentaServicio () {
      if (this.finishForm) return this.closeModal();
      if (this.validateForm()) return;

      this.isLoadingSaveAction = true;

      let cuentaServicio = this.prepareCuentaServicio();

      let request = {
        controller: '/CuentaServicio',
        filter: {},
        body: cuentaServicio
      };

      await this.$store
        .dispatch('PF/postSuit', request)
        .then(response => {
          this.finishForm = true;
          this.tokenResult = response.data.token;
          this.$eventHub.$emit('refreshCuentasServicioList');
        })
        .catch(err => {
          this.showError(err.message);
        })
        .finally(() => {
          this.isLoadingSaveAction = false;
        });
    },

    async editCuentaServicio () {
      if (this.validateForm()) return;

      this.isLoadingSaveAction = true;

      let cuentaServicio = this.prepareCuentaServicio();

      let request = {
        controller: `/CuentaServicio/${this.cuentaServicioSelected.id}`,
        filter: {},
        body: cuentaServicio
      };

      await this.$store
        .dispatch('PF/putSuit', request)
        .then(() => {
          this.closeModal();
          this.showMessage(
            `Se ha editado la cuenta de servicio ${this.cuentaServicioSelected.name} con éxito.`
          );
          this.$eventHub.$emit('refreshCuentasServicioList');
        })
        .catch(err => {
          this.showError(err.message);
        })
        .finally(() => {
          this.isLoadingSaveAction = false;
        });
    },
    prepareCuentaServicio () {
      let roleRelationship = [];
      roleRelationship = this.prepareRoleRelationship();

      let cuentaServicio = {};

      cuentaServicio.aplicacionId = this.dependecyApp.id;
      cuentaServicio.name = this.nameCuentaServicio;
      cuentaServicio.roles = roleRelationship;

      return cuentaServicio;
    },
    prepareRoleRelationship () {
      let roleRelationship = [];
      roleRelationship = this.roleRelationship.map(e => {
        return { aplicacionId: e.aplicacionId, rolId: e.roleId };
      });
      return roleRelationship;
    },
    refillData (data) {
      this.nameCuentaServicio = data.name;
      if (!data.roles) return;
      this.roleRelationship = data.roles.map(e => {
        return {
          aplicacionId: e.aplicacionId,
          aplicacionName: e.aplicacionName,
          roleId: e.rolId,
          roleName: e.rolName
        };
      });
    },
    copyTokenToClipBoard () {
      copyToClipboard(this.tokenResult)
        .then(() => {
          this.showMessage('Token copiado con éxito.');
        })
        .catch(() => {
          this.showError('Ha ocurrido un problema al copiar.');
        });
    }
  },
  watch: {
    value (isOpen) {
      this.openModal = isOpen;
    },
    openModal: {
      async handler (isOpen) {
        if (isOpen) {
          this.aplicacionesOpts = await this.loadAplicacionesOpts();
          return;
        }
        this.closeModal();
      },
      immediate: true
      // deep: true
    },
    cuentaServicioSelected (value) {
      if (Object.keys(value).length === 0) { return this.resetFormCuentaServicio(); }
      this.refillData(value);
    }
  }
};
</script>

<style lang="scss" scoped>
.form-view-cuentaservicio {
  &__title {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.23px;
    color: $azulcabecera;
  }
  &__item-token-container {
    display: flex;
    &__token-result {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 15px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.22px;
      color: rgba(0, 0, 0, 0.5);
    }
  }
}
</style>
